import { z } from "zod";

export const editExternalSupplierDetailsFormSchema = z.object({
  name: z.string().min(2, "Minimum of 2 characters.").max(100, "Maximum of 100 characters"),
  type: z.string().min(1, "Field is required and can't be empty."),
  state: z.string().min(1, "Field is required and can't be empty."),
  email: z.string().email("This is not a valid email.").min(2, "Minimum of 2 characters."),
  keyContactName: z.string().min(1, "Field is required and can't be empty.").max(50, "Maximum of 50 characters"),
  contactNumber: z
    .string({ description: "Please enter a valid phone number" })
    .min(1, "Field is required and can't be empty.")
    .max(14, "Maximum of 14 characters"),
});

export type EditExternalSupplierDetailsFormData = z.infer<typeof editExternalSupplierDetailsFormSchema>;
